import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/gracias/inscripcion")({
  head: () => buildRouteHead("/es/gracias/inscripcion", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/gracias/registro", replace: true });
  },
});
